<template>
  <footer class="py-5" :class="{ white: !home }">
    <img :src="line" class="footer__img" alt="Geodis line">
    <p class="footer__text text-center" :class="{ 'footer__text--white': home }">
      @2020
      <a href="https://geodis.com" target="_blank">GEODIS</a>
      - All rights reserved
      <!-- <router-link :to="{ name: 'GDPR.index' }">GDPR</router-link> |
      <a href="#">Legal information</a> -->
    </p>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
  props: {
    home: Boolean,
  },
  computed: {
    line() {
      return `/images/${this.home ? 'footer-white' : 'footer-blue'}.png`;
    },
  },
};
</script>
